import { NotificacaoDto } from '@/api.types';
import api, { GetApiReturn, GetApiReturnError, ValidateAxiosError, ValidateAxiosErrorSemRedirecionar, } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';

/**
 * Lista de Notificações.
 * @param {boolean} popup se deve exibir somente as notificações que não foram a popup.
 * @returns Notificações do usuário.
 */
export async function GetNotificacoes(popup: boolean) {
  return api
    .get(Endpoints.NOTIFICACAO + '/' + popup)
    .then((response) => {
      return GetApiReturn<NotificacaoDto>(response.data as Array<NotificacaoDto>);
    })
    .catch((error) => {
      ValidateAxiosErrorSemRedirecionar<NotificacaoDto>(
        error,
        'Falha ao listar notificações.',
      );
      return GetApiReturnError<NotificacaoDto>();
    });
}

/**
 * Define que uma notificação foi lida (popup = true).
 * @param {string} id se deve exibir somente as notificações que não foram a popup.
 * @returns
 */
export async function SetNotificacao(id: string) {
  return api
    .patch(Endpoints.NOTIFICACAO + '/' + id)
    .then(() => {
      return 'Notificação Lida';
    })
    .catch((error) => {
      return ValidateAxiosError<string[]>(
        error,
        'Falha ao atualizar notificação.',
      );
    });
}

/**
 * Apaga um notificação do usuário.
 * @param {string} id Identificação da notificação.
 * @returns true se apagou, false em caso contrário.
 */
export async function DeleteNotificaco(id: string) {
  return api
    .delete(Endpoints.NOTIFICACAO + '/' + id)
    .then(() => {
      return 'Notificação removida.';
    })
    .catch((error) => {
      return ValidateAxiosError<string>(error, 'Falha ao remover Notificação.');
    });
}
